export class TipoHabitacion {

    public intId?:number;
    public strAbreviatura?:string;
    public strNombre?:string;
    public intCapacidad?:number;
    public strActivo?:string;
}
